import { gql } from 'apollo-boost';

export const SHARE_FOLDER = gql`
    mutation shareFolder($data: ShareFolderInput!) {
        shareFolder(data: $data) {
            sharedEmails
            notFoundEmails
        }
    }
`;
